// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhk_ji","CommentListPlaceholder--Legacy":"ih_b bhk_ra bhk_wo"};